export const SET_PASSENGER_SSR_TO_DELETE = 'SET_PASSENGER_SSR_TO_DELETE'

export default (passengerId: string, passengerSSRId: string) => ({
  type: SET_PASSENGER_SSR_TO_DELETE,
  passengerId,
  passengerSSRId,
})
